// Maximum invoices/estimates per bulk-send email.
// Must stay in sync with BULK_EMAIL_MAX_ATTACHMENTS in backend/utils.py.
export const BULK_BATCH_SIZE = 30;

// Maximum number of emails sent per bulk-send action (BULK_BATCH_SIZE × BULK_MAX_BATCHES = total cap).
export const BULK_MAX_BATCHES = 4;
